import ApplicationController from './application_controller.js'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends ApplicationController {
  static targets = ['date', 'resolution', 'table', 'group']
  static values = { index: Number }

  connect() {
    // Sync date and resolution to export form when changed
    this.dateTarget.addEventListener('change', () => this.syncToExportForm())
    this.resolutionTarget.addEventListener('change', () =>
      this.syncToExportForm()
    )
  }

  syncToExportForm() {
    const exportDate = document.getElementById('export-date')
    const exportResolution = document.getElementById('export-resolution')

    if (exportDate) exportDate.value = this.dateTarget.value
    if (exportResolution) exportResolution.value = this.resolutionTarget.value
  }

  submit(event) {
    event.preventDefault()

    const date = this.dateTarget.value
    const resolution = this.resolutionTarget.value

    if (!date || !resolution) return

    const resultsDiv = document.getElementById('calculation-results')
    resultsDiv.innerHTML = "<p class='italic text-gray-500'>Calculating...</p>"

    // Run calculations for both MW and MWh separately
    Promise.all([this.fetchCalculation(date, resolution, 'MW')])
      .then((responses) => {
        return Promise.all(responses.map((response) => response.text()))
      })
      .then((htmlResults) => {
        // Combine both results and render
        const combinedHtml = this.combineResults(htmlResults)
        Turbo.renderStreamMessage(combinedHtml)
      })
      .catch((error) => {
        resultsDiv.innerHTML =
          "<p class='italic text-red-500'>Error calculating results</p>"
        console.error('Calculation error:', error)
      })
  }

  fetchCalculation(date, resolution, unit) {
    return fetch(
      `/admin/mscons_time_series/run_calculation?date=${date}&resolution=${resolution}&unit=${unit}`,
      {
        headers: { Accept: 'text/vnd.turbo-stream.html' }
      }
    )
  }

  combineResults(htmlResults) {
    // Extract the content from each turbo stream and combine them
    const parser = new DOMParser()
    const mwDoc = parser.parseFromString(htmlResults[0], 'text/html')

    const mwContent = mwDoc.querySelector('template')?.innerHTML || ''

    // Create a combined turbo stream with both results
    return `<turbo-stream action="replace" target="calculation-results">
      <template>
        <div id="calculation-results">
          <div class="gap-6">
            <div class="space-y-4">
              <h3 class="text-lg font-semibold text-blue-600">MW (Power) Calculations</h3>
              ${mwContent}
            </div>
          </div>
        </div>
      </template>
    </turbo-stream>`
  }

  selectCalculation(event) {
    const clickedTab = event.currentTarget
    const index = parseInt(event.params.index)
    this.indexValue = index

    this.groupTargets.forEach((el, i) => {
      el.classList.toggle('hidden', i !== index)
    })

    const parentTabs = Array.from(clickedTab.parentNode.children)
    parentTabs.forEach((tab) => tab.classList.remove('tab-active'))
    clickedTab.classList.add('tab-active')
  }

  selectTable(event) {
    const clickedTab = event.currentTarget
    const index = parseInt(event.params.tabIndex)
    this.indexValue = index

    const currentGroup = clickedTab.closest("[data-calculation-target='group']")

    const tablesInThisGroup = Array.from(
      currentGroup.querySelectorAll("[data-calculation-target='table']")
    )

    tablesInThisGroup.forEach((el, i) => {
      el.classList.toggle('hidden', i !== index)
    })

    const childTabs = Array.from(clickedTab.parentNode.children)
    childTabs.forEach((tab) => tab.classList.remove('tab-active'))
    clickedTab.classList.add('tab-active')
  }
}
